// extracted by mini-css-extract-plugin
export var actionText = "_nr-4";
export var container = "_nr-0";
export var leftSection = "_nr-1";
export var rightSection = "_nr-2";
export var settingsButton = "_nr-6";
export var settingsIcon = "_nr-7";
export var shortcut = "_nr-5";
export var shortcutGroup = "_nr-3";